import { render, staticRenderFns } from "./RadioBox.vue?vue&type=template&id=66ad4bdb&scoped=true"
import script from "./RadioBox.vue?vue&type=script&lang=js"
export * from "./RadioBox.vue?vue&type=script&lang=js"
import style0 from "./RadioBox.vue?vue&type=style&index=0&id=66ad4bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad4bdb",
  null
  
)

export default component.exports